"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass.js");

var _get = require("/opt/build/repo/node_modules/@babel/runtime/helpers/get.js");

var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var InvalidationPolicyManager_1 = __importDefault(require("../policies/InvalidationPolicyManager"));

var AuditType;

(function (AuditType) {
  AuditType["Read"] = "Read";
  AuditType["Write"] = "Write";
  AuditType["Evict"] = "Evict";
})(AuditType = exports.AuditType || (exports.AuditType = {}));

var InvalidationPolicyManagerAuditor = /*#__PURE__*/function (_InvalidationPolicyMa) {
  _inherits(InvalidationPolicyManagerAuditor, _InvalidationPolicyMa);

  var _super = _createSuper(InvalidationPolicyManagerAuditor);

  function InvalidationPolicyManagerAuditor(config) {
    var _this;

    _classCallCheck(this, InvalidationPolicyManagerAuditor);

    _this = _super.call(this, config);
    _this.auditLog = config.auditLog;
    return _this;
  }

  _createClass(InvalidationPolicyManagerAuditor, [{
    key: "runReadPolicy",
    value: function runReadPolicy(_ref) {
      var typename = _ref.typename,
          dataId = _ref.dataId,
          fieldName = _ref.fieldName,
          storeFieldName = _ref.storeFieldName,
          _ref$reportOnly = _ref.reportOnly,
          reportOnly = _ref$reportOnly === void 0 ? false : _ref$reportOnly;
      this.auditLog.log("Running read policy", AuditType.Read, "InvalidationPolicyManager", {
        storeFieldName: storeFieldName,
        typename: typename,
        dataId: dataId,
        fieldName: fieldName
      });
      return _get(_getPrototypeOf(InvalidationPolicyManagerAuditor.prototype), "runReadPolicy", this).call(this, {
        typename: typename,
        dataId: dataId,
        fieldName: fieldName,
        storeFieldName: storeFieldName,
        reportOnly: reportOnly
      });
    }
  }, {
    key: "runWritePolicy",
    value: function runWritePolicy(typeName, policyMeta) {
      this.auditLog.log("Running write policy", AuditType.Write, "InvalidationPolicyManager", Object.assign({
        typeName: typeName
      }, policyMeta));
      return _get(_getPrototypeOf(InvalidationPolicyManagerAuditor.prototype), "runWritePolicy", this).call(this, typeName, policyMeta);
    }
  }, {
    key: "runEvictPolicy",
    value: function runEvictPolicy(typeName, policyMeta) {
      this.auditLog.log("Running evict policy", AuditType.Write, "InvalidationPolicyManager", Object.assign({
        typeName: typeName
      }, policyMeta));
      return _get(_getPrototypeOf(InvalidationPolicyManagerAuditor.prototype), "runEvictPolicy", this).call(this, typeName, policyMeta);
    }
  }]);

  return InvalidationPolicyManagerAuditor;
}(InvalidationPolicyManager_1.default);

exports.default = InvalidationPolicyManagerAuditor;